'use strict';

const loader = (function(){
    function start(elems, showPopup = true) {
        const elements = !elems ? [] : typeof elems.classList !== 'undefined' ? [elems] : elems;
        for (let elem of elements) {
            elem.classList.add('is-loading');
            if (showPopup) {
                const loadElem = document.createElement('div');
                const text = document.createTextNode('Ladataan dataa...');
                loadElem.classList.add('loader');
                loadElem.appendChild(text);
                elem.appendChild(loadElem);
            }
        }
    }

    function end(elems) {
        const elements = !elems ? [] : typeof elems.classList !== 'undefined' ? [elems] : elems;
        for (let elem of elements) {
            for (let child of elem.children) {
                if (child.classList && child.classList.contains('loader')) {
                    elem.removeChild(child);
                    break;
                }
            }
            elem.classList.remove('is-loading');
        }
    }

    return {
        start: start,
        end: end
    }
})();

export default loader;
